import { createIcon } from '@chakra-ui/react';

export const StripeLogoIcon = createIcon({
  displayName: 'StripeLogoIcon',
  path: (
    <svg fill="none" viewBox="100 100 312 312">
      <path
        fill="#533afd"
        fillRule="evenodd"
        d="m120 392 272-57.683V120l-272 58.357z"
        clipRule="evenodd"
      />
    </svg>
  ),
});